import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import { PAGE_SIZE_OPTIONS } from "../../Constants/FieldOptions";

function OrgPromoCodeMobileList(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
    onDeletePromoCode,
  } = props;
  return (
    <>
      {listData &&
        listData.map(function (datum, i) {
          return (
            <div class="mb-5" key={datum.id}>
              <hr />
              <strong>Promo code:</strong>&nbsp;{datum.name}
              <br />
              <br />
              <strong>Description:</strong>&nbsp;{datum.description}
              <br />
              <br />
              <strong>Start date:</strong>&nbsp;
              {datum.startDate}
              <br />
              <br />
              <strong>Expiry date:</strong>&nbsp;
              {datum.endDate}
              <br />
              <br />
              <strong>Discount:</strong>&nbsp;{datum.discount}%
              <br />
              <br />
              <strong> Limit of usage :</strong>&nbsp;
              {datum.usageLimit}
              <br />
              <br />
              <strong> Users :</strong>&nbsp;
              {datum.usesCount}
              <br />
              {/* Tablet only */}
              <div class="is-hidden-mobile pt-2">
                <div className="buttons is-right">
                  <Link
                    to={"/org-promo-code/details/" + datum.id}
                    class="button is-small is-primary"
                    type="button"
                  >
                    <FontAwesomeIcon className="mdi" icon={faEye} />
                    &nbsp;View
                  </Link>
                  <div
                    onClick={() => onDeletePromoCode(datum.id)}
                    className="button is-small"
                  >
                    <FontAwesomeIcon className="mdi" icon={faTrash} />
                  </div>
                </div>
              </div>
              {/* Mobile only */}
              <div class="is-hidden-tablet pt-2">
                <div class="columns is-mobile">
                  <div class="column">
                    <Link
                      to={"/org-promo-code/details/" + datum.id}
                      class="button is-small is-primary is-fullwidth"
                      type="button"
                    >
                      <FontAwesomeIcon className="mdi" icon={faEye} />
                      &nbsp;View
                    </Link>
                    <div
                      onClick={() => onDeletePromoCode(datum.id)}
                      className="button is-small"
                    >
                      <FontAwesomeIcon className="mdi" icon={faTrash} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      <div class="columns pt-4">
        <div class="column is-half">
          <span class="select">
            <select
              class={`input has-text-grey-light`}
              name="pageSize"
              onChange={(e) => setPageSize(parseInt(e.target.value))}
            >
              {PAGE_SIZE_OPTIONS.map(function (option, i) {
                return (
                  <option
                    selected={pageSize === option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                );
              })}
            </select>
          </span>
        </div>
        <div class="column is-half has-text-right">
          {previousCursors.length > 0 && (
            <button class="button" onClick={onPreviousClicked}>
              Previous
            </button>
          )}
          {listData.hasNextPage && (
            <>
              <button class="button" onClick={onNextClicked}>
                Next
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default OrgPromoCodeMobileList;
